import React from 'react';

export default function DataModelHelp() {
  return (
    <div className="help-banner card">
      <h3>How this fits together</h3>
      <ul>
        <li>
          <strong>User</strong> — Telegram recipient (who gets messages)
        </li>
        <li>
          <strong>Search</strong> — what to look for (query, filters, sites)
        </li>
        <li>
          <strong>Subscription</strong> — links a user to a search (&quot;notify me about this&quot;)
        </li>
      </ul>
      <p className="muted">
        To stop alerts: remove the <strong>subscription</strong> first. Delete the search or user only
        when nothing else needs them. Past sends stay in <strong>Activity</strong>.
      </p>
    </div>
  );
}
